import { makeUserManagementClient } from '@webdev/user-management';

const basePath = `/user-management-api/useraccount`;

export const userManagementClient = makeUserManagementClient(basePath);
